module.exports = __webpack_public_path__ + "img/logo.f16947d0.png";